import React from 'react';
import { useTranslation } from 'react-i18next';

import * as styles from './index.module.scss';
import { LanguageSwitcher } from './LanguageSwitcher';

type Item = {
  href: string;
  label: string;
};

export const AppFooter: React.FC = () => {
  const { t } = useTranslation();

  const items: Item[] = [
    {
      href: t('pages.external.corporateProfile.url'),
      label: t('pages.external.corporateProfile.title'),
    },
    {
      href: t('pages.support.termsOfUse.url'),
      label: t('pages.support.termsOfUse.title'),
    },
    {
      href: t('pages.support.privacy.url'),
      label: t('pages.support.privacy.title'),
    },
    {
      href: t('pages.support.recommendedEnvironment.url'),
      label: t('pages.support.recommendedEnvironment.title'),
    },
    {
      href: t('pages.support.faq.url'),
      label: t('pages.support.faq.title'),
    },
    {
      href: t('pages.external.inquiry.url'),
      label: t('pages.external.inquiry.title'),
    },
  ];

  return (
    <div className={styles.root}>
      <div className={styles.navSection}>
        <div className={styles.inner}>
          <div className={styles.items}>
            {items.map((item, index) => (
              <a
                key={index}
                href={item.href}
                rel="noopener noreferrer"
                target="_blank"
                className={styles.item}
              >
                {item.label}
              </a>
            ))}
          </div>
          <LanguageSwitcher />
        </div>
      </div>
      <div className={styles.copyrightSection}>
        © GLOBIS All Rights Reserved.
      </div>
    </div>
  );
};
